import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/preventive-stops';

export class StopsService extends RestServiceConnection {


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE PARADAS
     * @EN GETS THE LIST OF STOPS
     */
    // -------------------------------------------------------------------------------------------------------------
    listStops = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UNA PARADA POR SU ID
     * @EN GETS A STOPS BY ITS ID
     * 
     * @param carrionId
     */
    // -------------------------------------------------------------------------------------------------------------
    getStopsById = async (stopsId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { id : stopsId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UNA CARROÑA
     * @EN CREATES A PARADA
     * 
     * @param stops
     */
    // -------------------------------------------------------------------------------------------------------------
    createStop = async (stop: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: stop,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES IMPORTA PARADAS DESDE EXCEL
     * @EN IMPORTS STOPS FROM EXCEL
     *
     * @param formData
     */
    // -------------------------------------------------------------------------------------------------------------
    importStops = async (formData: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/import',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ACTUALIZA UNA CARROÑA
     * @EN UPDATES A CARRION
     * 
     * @param carrion
     */
    // -------------------------------------------------------------------------------------------------------------
    editStop = async (stop: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: stop,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UNA PARADA
     * @EN DELETES A PARADA
     * 
     * @param stopId
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteStop = async (stopId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { 
                id : stopId 
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIAS CARROÑAS
     * @EN DELETES MULTIPLE CARRIONS
     * 
     * @param carrionIds
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiStops = async (stopsIds: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { stopsIds },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA LOS ESTDOS DE PARADAS
     * @EN GETS THE LIST OF STOPS STATUS
     */
    // -------------------------------------------------------------------------------------------------------------
    listStatusStops = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-status',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CAMBIA EL ESTADO DE UNA PARADA
     * @EN CHANGES THE STATE OF A PARADA
     * 
     * @param stopId
     * @param statusId
     */
    // -------------------------------------------------------------------------------------------------------------
    changeStatusStop = async (stopId: string, statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/change-status',
            data: { 
                id: stopId,
                statusId: statusId
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EXPORTA A EXCEL
     * @EN EXPORTS TO EXCEL
     * 
     * @param filters
     */
    // -------------------------------------------------------------------------------------------------------------
    exportToExcel = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/export-to-excel',
            data: filters,
            responseType: 'blob',
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA LOS ESTDOS DE PARADAS
     * @EN GETS THE LIST OF STOPS STATUS
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelectStatusStops = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-select-status',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES VALIDA VARIAS PARADAS
     * @EN VALIDATES MULTIPLE STOPS
     * 
     * @param stopsIds
     */
    // -------------------------------------------------------------------------------------------------------------
    validateSelectedStops = async (stopsIds: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/validate-multiple',
            data: { ids : stopsIds },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}
